export const newBWICActions = {
    INIT: 'INIT',
    CHANGE_STEP: 'CHANGE_STEP',
    RESET_WIZARD: 'RESET_WIZARD',
    DEALERS_SET_SEARCH_TERM: 'DEALERS_SET_SEARCH_TERM',
    DEALERS_UPDATE_FILTER_OPTION: 'DEALERS_UPDATE_FILTER_OPTION',
    DEALERS_CLEAR_FILTER_OPTIONS: 'DEALERS_CLEAR_FILTER_OPTIONS'
};
